<template>
    <Tooltip
        v-if="isMounted && isAuthorized"
        :triggerClass="props.className"
        :content="$tr('gameContainer.logged_in_tooltip')"
    >
        <IconButton
            interfaceTarget="game-container-login-button"
            color="carbon-purple-400"
            icon="happy-cloud"
        />
    </Tooltip>
    <TooltipPopup
        v-else-if="isMounted && userInfoLoaded"
        ref="tooltip-popup"
        interfaceTarget="login-button-tooltip-popup"
        :triggerClass="props.className"
    >
        <IconButton
            interfaceTarget="game-container-login-button"
            color="rose-100"
            icon="sad-cloud"
            @click="layoutStore.openSignInModal('game-desktop-footer-login-button')"
        />
        <template #content="{ interfaceTarget }">
            <TooltipContent
                :image="CloudImage"
                :title="$tr('gameContainer.login_popup_header')"
                :description="$tr('gameContainer.login_popup_description')"
            >
                <SocialLogins
                    type="compact"
                    :loginSource="interfaceTarget"
                />
            </TooltipContent>
        </template>
    </TooltipPopup>
    <IconButton
        v-else
        interfaceTarget="game-container-login-button"
        color="carbon-purple-400"
        :icon="undefined"
        :class="props.className"
    />
</template>

<script setup lang="ts">
import { useMounted } from '@vueuse/core'
import { storeToRefs } from 'pinia'
import { useTemplateRef } from 'vue'

import IconButton from '@/components/Buttons/IconButton.vue'
import CloudImage from '@/components/images/cloud.webp'
import SocialLogins from '@/components/SocialLogins/SocialLogins.vue'
import Tooltip from '@/components/Tooltip/Tooltip.vue'
import TooltipPopup from '@/components/Tooltip/TooltipPopup.vue'
import { useUserInfoLoaded } from '@/composables/use-user-state'
import { useLayoutStore } from '@/store/layout-store'
import { useUserStore } from '@/store/user-store/user-store'

import TooltipContent from './TooltipContent.vue'

const props = defineProps<{
    className: string
}>()

const isMounted = useMounted()

const layoutStore = useLayoutStore()
const userStore = useUserStore()
const { isAuthorized } = storeToRefs(userStore)
const userInfoLoaded = useUserInfoLoaded()

const tooltipRef = useTemplateRef('tooltip-popup')

defineExpose({
    showTooltip: () => {
        tooltipRef.value?.showTooltip()
    },
})
</script>
